import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';

const LiteCollectionData = ({ value, onChange, label = 'Lite Collection Data', options = [] }) => {
    const [selectedLiteCollectionData, setSelectedLiteCollectionData] = useState(value || "");

    const handleLiteCollectionDataChange = (e) => {
        const newValue = e.target.value;
        setSelectedLiteCollectionData(newValue); // Update local state
        onChange(newValue); // Call onChange prop with the new value
    };

/*    useEffect(() => {
        if (!options.includes(selectedLiteCollectionData)) {
            setSelectedLiteCollectionData(""); // Reset selection if the options change and the current value is invalid
        }
    }, [options]);
*/
   useEffect(() => {
        // If the controlled value prop changes, sync the local state
        if (value !== selectedLiteCollectionData) {
            //setSelectedLiteCollectionData(value || "");
        }
        // Reset to empty string if current value isn't in the new options
        if (!options.some(option => option.id === selectedLiteCollectionData) && selectedLiteCollectionData !== "") {
            //setSelectedLiteCollectionData("");
            onChange(""); // Notify parent of reset
        }
    }, [value, options, onChange]);

    return (
        <div className="a-container">
            <label style={{ display: "none" }} htmlFor="LiteCollectionData">{label}</label>
            <select
                style={{ display: "none" }}
                id="LiteCollectionData"
                value={selectedLiteCollectionData}
                onChange={handleLiteCollectionDataChange}
            >
                <option value="">Select an option</option>
            </select>
        </div>
    );
};

export default LiteCollectionData;
